import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";
import { useCircles } from "./useCircles";
import {
  accessibleSubcircles as accessibleSubcirclesFor,
  canAccessMainCircle,
} from "../domain/circles/circleAccess";

export interface CircleAccessItem {
  circleId: string;
  name: string;
  description: string;
  isPublic: boolean;
  isSubCircle: boolean;
  parentCircle?: string;
  memberCount: number;
  createdAt: string;
  createdBy: string;
  circleApproved: boolean;
  logo: string;
  type: string;
}

export const useCanAccessMainCircle = (): boolean => {
  const { user } = useAuth();
  return canAccessMainCircle(user);
};

export const useAccessibleCircles = () => {
  const { user } = useAuth();
  const canAccessMainCircle = useCanAccessMainCircle();
  const circlesQuery = useCircles();

  const allCircles = useMemo(
    () => (circlesQuery.data || []) as CircleAccessItem[],
    [circlesQuery.data],
  );

  const allSubcircles = useMemo(
    () => allCircles.filter((circle) => circle.isSubCircle),
    [allCircles],
  );

  const accessibleSubcircles = useMemo(
    () => accessibleSubcirclesFor(allCircles, user),
    [allCircles, user],
  );

  return {
    circles: allCircles,
    subcircles: accessibleSubcircles,
    allSubcircles,
    canAccessMainCircle,
    isLoading: circlesQuery.isLoading,
    error: circlesQuery.error ? "Failed to load circles" : null,
    refetch: circlesQuery.refetch,
  };
};

